export default __webpack_public_path__ + "static/media/0002.40c7ec60.png";